import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import i18n from "./i18n";

const DEFAULT_LOCALE = "hy";
const OTHER_LOCALES = ["en"];

export const LocaleWrapper = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    const urlLocale = pathParts[0]; 

    if (urlLocale && urlLocale !== DEFAULT_LOCALE && OTHER_LOCALES.includes(urlLocale)) {
      if (i18n.language !== urlLocale) {
        i18n.changeLanguage(urlLocale);
        localStorage.setItem("i18nextLng", urlLocale);
      }
    }

    else if (urlLocale === DEFAULT_LOCALE) {
      const newPath = location.pathname.replace(`/${DEFAULT_LOCALE}`, "") || "/";
      navigate(newPath + location.search, { replace: true });
      if (i18n.language !== DEFAULT_LOCALE) {
        i18n.changeLanguage(DEFAULT_LOCALE);
        localStorage.setItem("i18nextLng", DEFAULT_LOCALE);
      }
    }

    else if (!urlLocale) {
      if (i18n.language !== DEFAULT_LOCALE) {
        i18n.changeLanguage(DEFAULT_LOCALE);
        localStorage.setItem("i18nextLng", DEFAULT_LOCALE);
      }
    }
  }, [location.pathname, navigate]);

  return children;
};